import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { ChangeWorkspaceBranchForm } from './ChangeWorkspaceBranchForm'

export const ChangeWorkspaceBranchButton = () => {
  const translate = useTranslate()

  return (
    <Popover>
      <PopoverButton as="div">
        <OperationsLoadedButton startIcon="Pencil">
          {translate('workspaceDetailsPanel.button.changeBranch')}
        </OperationsLoadedButton>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }} className="max-w-lg!">
        <ChangeWorkspaceBranchForm />
      </ActionsMenuPanel>
    </Popover>
  )
}
